module.exports = __webpack_public_path__ + "img/tab-deposit.c3ba7bdb.png";